<template>
    
    <div class="result-text-type-container">
        <div class="result-text-type-response" v-for="(item, index) in items" :key="index">
            <p>
                {{item.text}}
            </p>
        </div>

        
    </div>
</template>
<script>

export default {
    props: ['items'],
    components: {  },
   
    computed: {
      
    },
    data(){
        return{
            // items: [
            //     {
            //         text: "9:00",
            //         count: "4",
            //         active: false,
            //     }
            // ]
          

          

        }
    },
    mounted(){
    },

    methods:{
        
    }


   
}
</script>

<style lang="scss">
    
    .result-text-type{

        &-container{
            max-height: 200px;
            padding: 0 5px;
            overflow-y: auto;
        }
        
       &-response{
        background-color: #F7F7F7;
        padding: 0.3rem 1rem;
        margin-bottom: 10px;
        border-radius: 6px;

        p{
            font-size: .7rem;
        }
       }
    }
</style>